import React, {Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import routes from "routes";
import {AuthPageLayout} from "./layouts/AuthPageLayout/AuthPageLayout";
import {FullPageLayout} from "./layouts/FullPageLayout/FullPageLayout";
import {EmptyPageLayout} from "./layouts/EmptyPageLayout/EmptyPageLayout";
import {Admin} from "pages/Admin/Admin";
import {ToastMessage} from "components/shared/ToastMessage/ToastMessage";
import { Redirects } from "components/Redirects/Redirects";
import { Tooltip } from "components/shared/Tooltip/Tooltip";
import Landing from "pages/Landing/Landing";
import { usePageTracking } from "hooks/usePageTracking";

const Login = React.lazy(() => import("pages/Auth/Login/Login"));
const Signup = React.lazy(() => import("pages/Auth/Signup/Signup"));
const PasswordEntry = React.lazy(() => import("pages/Auth/PasswordEntry/PasswordEntry"));
const PasswordReset = React.lazy(() => import("pages/Auth/PasswordReset/PasswordReset"));

const Onboarding = React.lazy(() => import("pages/Onboarding/Onboarding"));

const Activity = React.lazy(() => import("pages/Activity/Activity"));

const MyCases = React.lazy(() => import("pages/MyCases/MyCases"));
const AddCase = React.lazy(() => import("pages/MyCases/AddCase/AddCase"));

const AccountSettings = React.lazy(() => import("pages/Account/AccountSettings/AccountSettings"));
const EditProfile = React.lazy(() => import("pages/Account/EditProfile/EditProfile"));
const PasswordChange = React.lazy(() => import("pages/Account/PasswordChange/PasswordChange"));

const PrivacyPolicy = React.lazy(() => import("pages/PrivacyPolicy/PrivacyPolicy"));
const TermsAndConditions = React.lazy(() => import("pages/TermsAndConditions/TermsAndConditions"));

function App() {
  // Track page views on route changes
  usePageTracking();

  return (
    <>
      <Suspense fallback={null}>
          <Redirects />
          <Routes>
            <Route path={routes.landing} element={<Landing />} />
            <Route path="/auth" element={<EmptyPageLayout />}>
              <Route path={routes.auth.passwordEntry} element={<PasswordEntry />} />
              <Route path={routes.auth.passwordReset} element={<PasswordReset />} />
            </Route>
            <Route path="/auth" element={<AuthPageLayout />}>
              <Route path={routes.auth.login} element={<Login />} />
              <Route path={routes.auth.signup} element={<Signup />} />
              <Route index element={<Navigate to={routes.auth.login} />} />
            </Route>
            <Route path="/" element={<FullPageLayout />}>
              <Route path={routes.activity.main} element={<Activity />} />
              <Route path={routes.activity.details} element={<Activity />} />
              <Route path={routes.cases.main} element={<MyCases />} />
              <Route path={routes.cases.details} element={<MyCases />} />
              <Route path={routes.cases.details} element={<MyCases />} />
              <Route path={routes.cases.search} element={<AddCase />} />
              <Route path={routes.account.main} element={<AccountSettings />} />
              <Route path={routes.account.editProfile} element={<EditProfile />} />
              <Route path={routes.account.passwordChange} element={<PasswordChange />} />
            </Route>
            <Route element={<EmptyPageLayout />}>
              <Route path={routes.onboarding} element={<Onboarding />} />
            </Route>
            <Route element={<EmptyPageLayout isWhite={true} />}>
              <Route path={routes.privactPolicy} element={<PrivacyPolicy />} />
              <Route path={routes.termsOfUse} element={<TermsAndConditions />} />
            </Route>
            <Route path="/admin/*" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
      </Suspense>

      <ToastMessage />
      <Tooltip />
    </>
  );
}

export default App;
